// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__1_-h2","button":"button__2ZfOS"};